define(["jquery", "site/TEKsystems.SitecoreXP.Analytics"], function ($, analytics) {

    return function initScoreWrappedComponent(args) {

        this.InitializeTracking = function (scope, itemId) {
            analytics.Initialize(scope, itemId);
        }
        if (args.track) {
            this.InitializeTracking(args.scope, args.itemId);
        }
        if (args.MenuTracking) {
            analytics.InitializeMenuTracking(args.scope, args.itemId);
        }
    };
});